<template>
  <div class="project-material">

    <h3 class="title">领用记录</h3>
    <el-table :data="useListData" style="width: 100%" v-loading="useLoading">
      <el-table-column label="客户名称">
        <template slot-scope="scope">
          {{ scope.row.customer?scope.row.customer:'/' }}
        </template>
      </el-table-column>
      <el-table-column label="所属工程">
        <template slot-scope="scope">
          <router-link class="link" target="_blank" v-if="scope.row.projectId"
            :to="'/Project/Detail/'+scope.row.projectId">{{scope.row.projectName}}</router-link>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column label="材料领用申请人">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.flow.createTime)"></span>
        </template>
      </el-table-column>
      <el-table-column :key="Math.random()" prop="flow.status" label="审批状态" width="100">
      </el-table-column>
      <el-table-column label="出库状态" width="80" align="center">
        <template slot-scope="scope">
          <strong class="red" v-if="scope.row.type==0">未出库</strong>
          <strong class="green" v-else>已出库</strong>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row, '50')" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>


    <h3 class="title" style="margin-top:25px;">退库记录</h3>
    <el-table :data="backListData" style="width: 100%" v-loading="backLoading">
      <el-table-column label="客户名称">
        <template slot-scope="scope">
          {{ scope.row.customer?scope.row.customer:'/' }}
        </template>
      </el-table-column>
      <el-table-column label="所属工程">
        <template slot-scope="scope">
          <router-link class="link" target="_blank" v-if="scope.row.projectId"
            :to="'/Project/Detail/'+scope.row.projectId">{{scope.row.projectName}}</router-link>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column label="材料领用申请人">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column label="申请时间">
        <template slot-scope="scope">
          <span v-html="getDateByTime(scope.row.flow.createTime)"></span>
        </template>
      </el-table-column>
      <el-table-column :key="Math.random()" prop="flow.status" label="审批状态" width="100">
      </el-table-column>
      <el-table-column label="退库状态" width="80" align="center">
        <template slot-scope="scope">
          <strong class="red" v-if="scope.row.type==0">未退库</strong>
          <strong class="green" v-else>已退库</strong>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row, '51')" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <project-info></project-info>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import projectInfo from '@/page/user/projectInfo'
  import approvalType from '@/Mixins/approvalType'

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      projectInfo,
    },
    mixins: [approvalType, Role],
    props: ['projectId'],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 是否可切换公司
        noSelectOrganization: false,
        houseList: "",

        organizationListData: [],
        depId: '',
        addMeetingRoomStatus: false,

        form: {
          houseId: '',
          type: 0
        },
        // 列表
        useLoading: true,
        backLoading: true,
        useListData: [],
        backListData: [],

        // filter
        filterKey: "",
      }
    },
    created() {
      if (this.$route.params.houseId) {
        this.form.houseId = this.$route.params.houseId / 1
      }
      this.organizationListData = this.organization[0].childDepts
      this.depId = this.userData.secDepIds.split(",")[0] / 1
      // 获取仓库列表
      this.getLists()
    },
    mounted() {
      if (this.depId == "7") {
        this.noSelectOrganization = false
        this.depId = ""
      }
    },
    methods: {
      // 显示审批表详情
      projectDetail(row, type) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.id,
          // 强行吧tableType变成50 也就是仓库材料
          tableType: type,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      getDateByTime(time) {
        // return time
        return window.util.getFormatDate(time, true)
      },
      // 获取列表
      getLists() {
        this.useLoading = true
        ajax.get('/storage/material/project/apply/list', {
          projectId: this.projectId
        }, (res) => {
          this.useLoading = false
          this.useListData = res.vo.array
        })

        this.backLoading = true
        ajax.get('/storage/material/project/back/list', {
          projectId: this.projectId
        }, (res) => {
          this.backLoading = false
          this.backListData = res.vo.array
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/project/material.vue